import * as React from 'react';
import { InputBox, InputIcon, InputTextField } from './Input.style';
import { InputProps } from './Input.types';

export function Input(props: InputProps) {
  const { label, value, open, inputLarge, onOpenClick } = props;
  const inputProps = {
    className: 'hierarchy-input',
    endAdornment: <InputIcon open={open} />,
  };

  const labelProps = {
    className: 'hierarchy-label',
    shrink: true,
  }

  const handlerClick = React.useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    onOpenClick(e);
  }, []);

  return React.useMemo(() =>
    <InputBox className="hierarchy">
      <InputTextField
        label={label}
        value={value}
        open={open}
        inputLarge={inputLarge}
        onClick={handlerClick}
        InputProps={inputProps}
        InputLabelProps={labelProps}
      />
    </InputBox>
    , [value, open, label, inputLarge]);
}